import { useQuery } from '@src/shared/query';
import { selectAbsenceTypes } from '../../lib';
import { absenceTypeParams, typesUrl } from './constants';

export default function useAbsenceTypes() {
  const { data: absenceTypes = [], ...restQuery } = useQuery(typesUrl, {
    queryParams: absenceTypeParams,
    select: selectAbsenceTypes,
  });

  return {
    absenceTypes,
    ...restQuery,
  };
}
